<script setup lang="ts">
import PanelPageContainer from '@components/layout/org&panel&support/PanelPageContainer.vue';

const siteConfigs = useSiteConfigs();
const siteTitle = siteConfigs.title;
const title = `پیشنهادها و شکایات - ${siteTitle}`;
const desc = `در صورتی که پیشنهادی جهت ارتقای کیفیت خدمت‌رسانی در ${siteTitle} دارید یا در مورد یکی از خریدهای قبلی خود نیاز به پشتیبانی یا ثبت شکایت دارید، درخواست خود را از طریق فرم زیر ثبت کنید.`;

useSeoMeta({ title, description: desc, ogTitle: title, ogDescription: desc });
</script>

<template>
    <PanelPageContainer retain-box-in-mobile title="پیشنهادها و شکایات">
        <div class="container" dir="rtl">
            <h2 class="title">با ما در ارتباط باشید</h2>
            <p>
                در صورتی که پیشنهادی جهت ارتقای کیفیت خدمت‌رسانی در
                {{ siteConfigs.title }}
                دارید یا در مورد یکی از خریدهای قبلی خود نیاز به پشتیبانی یا ثبت
                شکایت دارید، درخواست خود را از طریق فرم زیر ثبت کنید. همکاران ما
                در واحد پشتیبانی پیشنهاد یا شکایت شما را بررسی می‌کنند و در صورت
                نیاز در اولین فرصت برای رفع مشکل با شما در ارتباط خواهند بود.
            </p>
            <mr-button>
                <a
                    class="link"
                    href="https://formafzar.com/form/pishnahad"
                    rel="nofollow noindex"
                >
                    پیشنهاد / شکایت جدید
                </a>
            </mr-button>
        </div>
    </PanelPageContainer>
</template>
<style lang="scss" scoped>
.title {
    color: usePalette();
}
.container {
    text-align: justify;
    padding: 10px;
}
.link {
    width: 100%;
    height: 100%;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
